// ============================================================================
// Guard: la rueda del mouse no debe modificar inputs numericos
// ============================================================================
// Los navegadores tratan la rueda sobre un <input type="number"> ENFOCADO como
// un incremento/decremento del valor. En pantallas de carga (valorizacion,
// costos, precios, stock) eso hace que al scrollear la grilla se alteren
// importes ya imputados, en silencio y sin que el usuario lo note.
//
// Se resuelve con un unico listener global en captura en vez de tocar los ~100
// inputs numericos repartidos por la app: cualquier input nuevo queda cubierto
// sin que haya que acordarse de agregar nada.
//
// Trade-off consciente: mientras el input numerico esta enfocado y el cursor
// esta encima, la rueda no scrollea la pagina (se cancela el evento). Es el
// comportamiento esperado — el usuario mueve el cursor fuera del input, o lo
// desenfoca, y el scroll vuelve a funcionar. Se prefiere eso a corromper un
// importe cargado.

let uninstall = null;

export function installNumberInputScrollGuard() {
  if (typeof document === 'undefined') return () => {};
  // Idempotente: si ya esta instalado, no duplicamos el listener.
  if (uninstall) return uninstall;

  const handleWheel = (event) => {
    const target = event.target;
    if (!target || target.tagName !== 'INPUT') return;
    if (target.type !== 'number') return;
    // Solo interceptamos cuando el input esta enfocado: es la unica situacion
    // en la que el browser cambiaria el valor. Si no lo esta, la rueda debe
    // scrollear normalmente.
    if (document.activeElement !== target) return;
    event.preventDefault();
  };

  // passive:false es obligatorio para poder llamar preventDefault sobre wheel.
  document.addEventListener('wheel', handleWheel, { passive: false });

  uninstall = () => {
    document.removeEventListener('wheel', handleWheel, { passive: false });
    uninstall = null;
  };
  return uninstall;
}

export default installNumberInputScrollGuard;
